import './products.scss'
import { SearchOutlined, PlusCircleOutlined, CalendarOutlined, DeleteOutlined, EyeOutlined, EditOutlined, StopOutlined, FilterOutlined } from '@ant-design/icons';
import React, { useEffect, useRef, useState } from 'react';
import Highlighter from 'react-highlight-words';
import { Button, Input, Space, Table, Popover, Popconfirm, Modal, message, Drawer, Pagination, Tag } from 'antd';
import './productsPremium.css';
import { Link, useNavigate } from 'react-router-dom';
import usePermissions from '../../hooks/usePermissions';
import axios from 'axios';
import config from '../../config';
import ProductDetail from './productDetail/ProductDetail';
import BarReturn from '../../components/barReturn/BarReturn';
import moment from 'moment';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import {
  NdoePage, NdoePageHeader, NdoeToolbar, NdoeActionButton,
  NdoeResponsiveTable, NdoeDataCard, NdoeStatusBadge, NdoeImage,
  NdoeRecherche, filtreTexte, optionsDe, compterActifs,
} from '../../components/ndoe';

/*
 * UNE FICHE BROUILLON — un modèle sans aucune pointure.
 *
 * Ce n'est PAS un état stocké en base, et c'est délibéré (voir produitCtrl) :
 * une telle fiche n'apparaît nulle part ailleurs qu'ici, ne peut pas être
 * vendue, et redevient ordinaire dès qu'une pointure arrive. L'état se déduit,
 * il n'a pas à être tenu à jour.
 *
 * On lit `nb_variantes`, que le serveur calcule. Le repli sur l'absence
 * d'entrée de stock est là pour une API plus ancienne — il confond « aucune
 * pointure » et « pointure sans mouvement », d'où le fait qu'il ne serve QUE de
 * repli.
 */
const estBrouillon = (record, stockByProduct = null) => {
  if (record && record.nb_variantes !== undefined && record.nb_variantes !== null) {
    return Number(record.nb_variantes) === 0;
  }
  return stockByProduct ? !stockByProduct[record.id_produit] : false;
};

const Products = () => {
    const DOMAIN = config.REACT_APP_SERVER_DOMAIN;
    const navigate = useNavigate();
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const [getProduit, setGetProduit] = useState();
    const [loading, setLoading] = useState(true);
    const searchInput = useRef(null);
    const [searchValue, setSearchValue] = useState('');
    // Facettes de la recherche unifiee (remplacent le panneau ProductSelects).
    const [marque, setMarque] = useState(undefined);
    const [categorie, setCategorie] = useState(undefined);
    const [open, setOpen] = useState(false);
    const [idProduit, setIdProduit] = useState({});
    const user = useSelector((state) => state.user?.currentUser);
    const [modalVisible, setModalVisible] = useState(false);
    const [selectedProductId, setSelectedProductId] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(15);
    const [pagination, setPagination] = useState({
      current: 1,
      pageSize: 15,
    });
    const [totalItems, setTotalItems] = useState('');
    // Vérité stock agrégée par produit (Lot A)
    const [stockByProduct, setStockByProduct] = useState({});
    const [stockFilter, setStockFilter] = useState('tous');
    /*
     * BROUILLONS — le filtre est SERVEUR, pas client.
     *
     * Les autres indicateurs comptent la PAGE affichée. Avec 43 pages, cela ne
     * permet pas de retrouver 26 fiches éparpillées : le filtre doit être posé
     * par la base. `?brouillons=1` s'en charge, et le total renvoyé est celui
     * de la sélection — donc la pagination reste juste.
     */
    const [voirBrouillons, setVoirBrouillons] = useState(false);
    const [nbBrouillons, setNbBrouillons] = useState(null);

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
      };
    const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText('');
      };

    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
          <div
            style={{
              padding: 8,
            }}
            onKeyDown={(e) => e.stopPropagation()}
          >
            <Input
              ref={searchInput}
              placeholder={`Search ${dataIndex}`}
              value={selectedKeys[0]}
              onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
              onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
              style={{
                marginBottom: 8,
                display: 'block',
              }}
            />
            <Space>
              <Button
                type="primary"
                onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                icon={<SearchOutlined />}
                size="small"
                style={{
                  width: 90,
                }}
              >
                Recherche
              </Button>
              <Button
                onClick={() => clearFilters && handleReset(clearFilters)}
                size="small"
                style={{
                  width: 90,
                }}
              >
                Supprimer
              </Button>
              <Button
                type="link"
                size="small"
                onClick={() => {
                  confirm({
                    closeDropdown: false,
                  });
                  setSearchText(selectedKeys[0]);
                  setSearchedColumn(dataIndex);
                }}
              >
                Filter
              </Button>
              <Button
                type="link"
                size="small"
                onClick={() => {
                  close();
                }}
              >
                close
              </Button>
            </Space>
          </div>
        ),
        filterIcon: (filtered) => (
          <SearchOutlined
            style={{
              color: filtered ? '#1677ff' : undefined,
            }}
          />
        ),
        onFilter: (value, record) =>
          record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
        onFilterDropdownOpenChange: (visible) => {
          if (visible) {
            setTimeout(() => searchInput.current?.select(), 100);
          }
        },
        render: (text) =>
          searchedColumn === dataIndex ? (
            <Highlighter
              highlightStyle={{
                backgroundColor: '#ffc069',
                padding: 0,
              }}
              searchWords={[searchText]}
              autoEscape
              textToHighlight={text ? text.toString() : ''}
            />
          ) : (
            text
          ),
      });

    const handleDelete = async (id) => {
      try {
        await axios.put(`${DOMAIN}/api/produit/produitDelete/${id}`);
        message.success('Produit supprimé.');
        fetchData(currentPage, pageSize);   // refetch au lieu de recharger toute la page
      } catch (err) {
        message.error("La suppression a échoué.");
        console.log(err);
      }
    };

    const handleTableChange = (paginationArg) => {
      setCurrentPage(paginationArg.current);
      setPageSize(paginationArg.pageSize);

      setPagination({
        current: paginationArg.current,
        pageSize: paginationArg.pageSize,
      });

      fetchData(paginationArg.current, paginationArg.pageSize);
    };

  const columns = [
    { title: '#', width: 58,
      dataIndex: 'id',
      key: 'id',
      render: (text, record, index) => {
        const size = pagination.pageSize || 15;
        const pageIndex = pagination.current || 1;
        return (pageIndex - 1) * size + index + 1;
      }
    },
    {
      title: 'image',
      width: 92,   // 72 px de vignette + les marges de cellule
      dataIndex: 'img',
      key: 'img',
      render: (text, record) => (
        <NdoeImage src={record.img} alt={record.nom_produit || 'Produit'} size="lg" />
      ),
    },
    {
        title: 'Nom produit',
        dataIndex: 'nom_produit',
        key: 'nom_produit',
        /*
          ⚠ LE NOM DÉBORDAIT SUR LA COLONNE VOISINE (signalé le 22/08/2026,
          capture à l’appui : « ESCARPINS OUVERTS DERRIERES VERNIS ROUGE BO »
          passait par-dessus « phys 1 · rés 0 · circ 0 »).

          La cause : le nom était rendu dans un <Tag> antd. Un Tag est en
          `inline-block` avec `white-space: nowrap` et NE SE RÉTRACTE PAS — il
          impose sa largeur à la cellule, qui déborde. Le filet CSS du design
          system (`.ndoe-table .ant-tag { max-width: 100% }`) ne l’attrapait pas :
          le Tag vivait dans un <Space>, dont la largeur est celle de son contenu.

          Et sur le fond, une étiquette porte un STATUT, pas un titre. Le nom
          redevient donc du texte — cliquable, tronqué proprement, avec le nom
          complet en infobulle et la référence en dessous, comme sur les listes
          de ventes et de qualification.
        */
        width: 260,
        ...getColumnSearchProps('nom_produit'),
        render: (text, record) => (
          <Space direction="vertical" size={2} style={{ width: '100%', minWidth: 0 }}>
            <button
              type="button"
              className="pr-nom"
              title={text}
              onClick={() => showModal(record.id_produit)}
            >
              {text}
            </button>
            {record.code_produit && <span className="pr-ref num">{record.code_produit}</span>}
            {/* LE SIGNAL SE MET OÙ L'ŒIL SE POSE (17/08/2026).
                La colonne « Disponible » disait déjà « Aucune pointure —
                invendable », mais loin à droite. La propriétaire a signalé
                « un article sans pointure et sans photo » : ce qu'on remarque,
                c'est la vignette vide à côté du nom. On le dit donc ICI, et on
                dit quoi faire. */}
            {estBrouillon(record) && (
              <Tag color="gold" style={{ margin: 0, whiteSpace: 'normal' }}>
                Brouillon — ajoutez ses pointures
              </Tag>
            )}
          </Space>
        )
    },
    {
      title: 'Disponible',
      width: 190,
      key: 'disponible',
      render: (text, record) => {
        const t = stockByProduct[record.id_produit];
        // Un produit SANS AUCUNE VARIANTE n'a pas d'entrée de stock : il
        // affichait un « — » muet, indistinguable d'une rupture. Or il est
        // INVENDABLE — aucune pointure n'existe, il ne peut apparaître nulle
        // part. Mesuré en prod : 12 produits dans ce cas, tous à zéro mouvement
        // et zéro réception, certains depuis 2024 : des créations abandonnées.
        // On le dit, au lieu de le laisser deviner (c'est ce qui a fait chercher
        // en vain un produit tout juste créé).
        if (!t) {
          return (
            <Tag color="orange" style={{ margin: 0 }}>
              Aucune pointure — invendable
            </Tag>
          );
        }
        return (
          <Space direction="vertical" size={0}>
            <Tag color={t.disponible > 0 ? 'green' : 'red'} style={{ margin: 0 }}>
              {t.disponible > 0 ? `${t.disponible} dispo.` : 'Rupture'}
            </Tag>
            <span style={{ fontSize: 10, color: '#8a93a3' }}>
              phys {t.physique} · rés {t.reservee} · circ {t.en_circulation} · av {t.avariees}
            </span>
            {(t.deconseille || t.avariees > 0) && (
              <Space size={2} wrap>
                {t.deconseille && <Tag color="orange" style={{ margin: 0 }}>Déconseillé</Tag>}
                {t.avariees > 0 && <Tag color="volcano" style={{ margin: 0 }}>{t.avariees} mauvais état</Tag>}
              </Space>
            )}
          </Space>
        );
      },
    },
    {
      title: 'Categorie',
      width: 170,
      dataIndex: 'nom_categorie',
      key: 'nom_categorie',
      render: (text) =>
          <Tag color={'orange'}>
            {text}
          </Tag>
    },
    {
      title: 'Marque',
      width: 130,
      dataIndex: 'nom_marque',
      key: 'nom_marque',
      render: (text) =>
          <Tag color={'blue'}>
            {text}
          </Tag>
    },
    {
      title: 'Matière',
      width: 130,
      dataIndex: 'nom_matiere',
      key: 'nom_matiere',
      render: (text) =>
          <Tag color={'rgb(128, 128, 231)'}>
            {text}
          </Tag>
    },
    {
      title: 'Famille',
      width: 140,
      dataIndex: 'nom_famille',
      key: 'nom_famille',
      render: (text) =>
          <Tag color={'blue'}>
            {text}
          </Tag>
    },
    {
      title: 'Etat produit',
      width: 120,
      dataIndex: 'etatProduit',
      key: 'etatProduit',
      ...getColumnSearchProps('etatProduit'),
      render: (text, record) => {
        const color = record.etatProduit === 'Actif' ? 'green' : 'red';
        return <Tag color={color} onClick={()=> handleOk(record.id_produit)} style={{cursor:'pointer'}}>
                {text}
              </Tag>;
      },
    },
    {
      title: "Date d'entrée",
      width: 130,
      dataIndex: 'date_entrant',
      key: 'date',
      sorter: (a, b) => moment(a.date_entrant).unix() - moment(b.date_entrant).unix(),
      sortDirections: ['descend', 'ascend'],
      render: (text) => (
        <Tag color={'blue'} icon={<CalendarOutlined />}>
          {moment(text).format('DD-MM-yyyy')}
        </Tag>
      ),
    },
    {
      title: 'Action',
      width: 200,
      key: 'action',
        render: (text, record) => (
          <Space size="middle">
             <Popover title="Voir les details" trigger="hover">
              <Button icon={<EyeOutlined />} style={{ color: 'green' }} onClick={()=> showModal(record.id_produit)} />
            </Popover>
            <Popover
              title={estBrouillon(record)
                ? 'Cette fiche n’a aucune pointure — en ajouter'
                : 'Ajoutez des produits'}
              trigger="hover"
            >
              <Link to={`/productView/${record.id_produit}`}>
                <Button
                  icon={<PlusCircleOutlined />}
                  // Une fiche vide n'a qu'un geste utile : la compléter. On le
                  // met en avant plutôt que de le laisser au même rang que le
                  // reste.
                  type={estBrouillon(record) ? 'primary' : 'default'}
                  style={estBrouillon(record) ? undefined : { color: 'blue' }}
                />
              </Link>
            </Popover>
            {user?.role === 'admin' &&
            <Popover title={stockByProduct[record.id_produit]?.deconseille ? 'Rétablir la recommandation' : 'À ne plus recommander'} trigger="hover">
              <Button
                icon={<StopOutlined />}
                style={{ color: stockByProduct[record.id_produit]?.deconseille ? '#c28a27' : '#aaa' }}
                onClick={() => toggleDeconseille(record.id_produit)}
              />
            </Popover>}
            {user?.role === 'admin' &&
            <Popover title="Supprimer" trigger="hover">
              <Popconfirm
                title="Êtes-vous sûr de vouloir supprimer?"
                onConfirm={() => handleDelete(record.id_produit)}
                okText="Oui"
                cancelText="Non"
              >
                <Button icon={<DeleteOutlined />} style={{ color: 'red' }} />
              </Popconfirm>
            </Popover>}
          </Space>
        ),
    },
  ];

  const fetchData = async (page = currentPage, size = pageSize) => {
    try {
      const { data } = await axios.get(`${DOMAIN}/api/produit`,{
        params: {
          page: page,
          pageSize: size,
          // Absent quand on ne filtre pas : une API plus ancienne l'ignore et
          // se comporte exactement comme avant.
          ...(voirBrouillons ? { brouillons: '1' } : {}),
        },
      });
      setGetProduit(data.data);
      setTotalItems(data.total);
      setLoading(false)
    } catch (error) {
      console.log(error);
      setLoading(false)
    }
  };

useEffect(() => {
  fetchData(currentPage, pageSize);
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [currentPage, pageSize, voirBrouillons]);

/*
 * COMBIEN DE FICHES RESTENT À COMPLÉTER ?
 *
 * Une seule ligne demandée : on ne veut que le TOTAL, pas les données. Non
 * bloquant — si l'API est plus ancienne et ignore le paramètre, elle renvoie le
 * total général ; on n'affiche alors rien plutôt qu'un chiffre faux.
 */
useEffect(() => {
  let vivant = true;
  axios.get(`${DOMAIN}/api/produit`, { params: { page: 1, pageSize: 1, brouillons: '1' } })
    .then(({ data }) => {
      if (!vivant) return;
      const n = Number(data && data.total);
      const premier = (data && data.data && data.data[0]) || null;
      // Garde-fou : si le serveur ne connaît pas le filtre, il rend TOUT le
      // catalogue. On le reconnaît à une fiche qui porte des pointures.
      const filtreCompris = !premier || Number(premier.nb_variantes) === 0;
      setNbBrouillons(Number.isFinite(n) && filtreCompris ? n : null);
    })
    .catch(() => { if (vivant) setNbBrouillons(null); });
  return () => { vivant = false; };
}, [DOMAIN, getProduit]);

// Navigation croisée (Lot E) : pré-remplit la recherche depuis ?q= (ouverture
// depuis le Catalogue visuel).
useEffect(() => {
  const q = new URLSearchParams(window.location.search).get('q');
  if (q) setSearchValue(q);
}, []);

// Enrichit la page courante avec la vérité stock agrégée par produit.
useEffect(() => {
  const ids = [...new Set((getProduit || []).map((p) => p.id_produit).filter(Boolean))];
  if (!ids.length) { setStockByProduct({}); return undefined; }
  let cancelled = false;
  (async () => {
    try {
      const { data } = await axios.post(`${DOMAIN}/api/catalogue/stock/produits/by-ids`, { ids });
      if (cancelled) return;
      const map = {};
      (data.produits || []).forEach((p) => { map[p.id_produit] = p; });
      setStockByProduct(map);
    } catch (e) {
      // Le tableau reste utilisable sans l'enrichissement.
    }
  })();
  return () => { cancelled = true; };
}, [getProduit, DOMAIN]);

const toggleDeconseille = async (idProduitArg) => {
  const t = stockByProduct[idProduitArg] || {};
  const next = !t.deconseille;
  const motif = next ? (window.prompt('Motif (optionnel) — pourquoi ne plus recommander ce modèle ?') || null) : null;
  try {
    await axios.put(`${DOMAIN}/api/catalogue/produit/${idProduitArg}/recommandation`, { deconseille: next, motif });
    setStockByProduct((m) => ({ ...m, [idProduitArg]: { ...(m[idProduitArg] || {}), deconseille: next } }));
    message.success(next ? 'Modèle marqué « à ne plus recommander ».' : 'Recommandation rétablie.');
  } catch (e) {
    message.error(e?.response?.data?.error || 'Action échouée.');
  }
};

const showModal = (e) => {
  setOpen(true);
  setIdProduit(e)
};

const handleOk = async (e) => {
  setSelectedProductId(e);
  setModalVisible(true);
};

// Filtre vérité stock (pastilles) — client, sur la page courante, comme la recherche.
const matchStock = (item) => {
  if (stockFilter === 'tous') return true;
  const t = stockByProduct[item.id_produit];
  if (!t) return false;
  if (stockFilter === 'disponible') return t.disponible > 0;
  if (stockFilter === 'rupture') return t.disponible <= 0;
  if (stockFilter === 'deconseille') return !!t.deconseille;
  if (stockFilter === 'avarie') return t.avariees > 0;
  return true;
};

// Zone libre : plusieurs mots = ET (« nike escarpin » = les escarpins Nike).
// Avant, c'était un OU sur 5 champs : dès deux mots, plus aucun résultat.
// Le code produit et la référence s'y ajoutent — on les a souvent en main sans
// que rien n'ait jamais indiqué qu'on pouvait les taper ici.
const filteredData = (getProduit || [])
  .filter(filtreTexte(searchValue, [
    'nom_produit', 'nom_categorie', 'nom_marque', 'etatProduit', 'nom_famille',
    'code_produit', 'code_article', 'nom_matiere', 'nom_cible',
  ]))
  .filter((p) => !marque || String(p.nom_marque) === marque)
  .filter((p) => !categorie || String(p.nom_categorie) === categorie)
  .filter(matchStock)

// Indicateurs (Lot C) — comptes sur la page courante (comme la recherche/filtre).
const pageStats = (getProduit || []).reduce((acc, p) => {
  const t = stockByProduct[p.id_produit];
  acc.total += 1;
  if (t) {
    if (t.disponible > 0) acc.dispo += 1; else acc.rupt += 1;
    if (t.deconseille) acc.deco += 1;
    if (t.avariees > 0) acc.avar += 1;
  }
  return acc;
}, { total: 0, dispo: 0, rupt: 0, deco: 0, avar: 0 });
const indicateurs = [
  { key: 'tous', label: 'Produits (page)', value: pageStats.total },
  { key: 'disponible', label: 'Disponibles', value: pageStats.dispo },
  { key: 'rupture', label: 'Ruptures', value: pageStats.rupt },
  { key: 'deconseille', label: 'Déconseillés', value: pageStats.deco },
  { key: 'avarie', label: 'Mauvais état', value: pageStats.avar },
];
// Posé à part : c'est le SEUL indicateur qui compte tout le catalogue et non la
// page. Le mélanger aux autres ferait croire qu'ils se lisent pareil.
const indicateurBrouillons = nbBrouillons === null
  ? null
  : { key: 'brouillons', label: 'Brouillons', value: nbBrouillons };

  // CORRIGER UNE FICHE (10/08/2026). L'écran existait mais n'était ouvert par
  // AUCUN bouton, et appelait deux routes absentes : une fiche mal saisie restait
  // définitive. Le geste est gardé par `produits.modifier_fiche` — administrateur
  // au départ, élargissable personne par personne dans la matrice.
  const { can } = usePermissions();
  const peutCorriger = can('produits.modifier_fiche');

  // --- Carte produit (mobile) ---
  const renderProductCard = (record) => {
    const t = stockByProduct[record.id_produit];
    const tone = !t ? 'neutral' : (t.disponible > 0 ? 'ok' : 'danger');
    const label = !t ? '—' : (t.disponible > 0 ? `${t.disponible} dispo.` : 'Rupture');
    const actions = [
      <NdoeActionButton key="v" size="sm" variant="ink" icon={<EyeOutlined />} onClick={() => showModal(record.id_produit)}>Voir</NdoeActionButton>,
      <NdoeActionButton key="a" size="sm" variant="secondary" icon={<PlusCircleOutlined />} onClick={() => navigate(`/productView/${record.id_produit}`)}>Variantes</NdoeActionButton>,
      peutCorriger && (
        <NdoeActionButton key="m" size="sm" variant="ghost" icon={<EditOutlined />} onClick={() => navigate(`/productForm/${record.id_produit}`)}>
          Corriger
        </NdoeActionButton>
      ),
      user?.role === 'admin' && (
        <NdoeActionButton key="dc" size="sm" variant="ghost" icon={<StopOutlined />} onClick={() => toggleDeconseille(record.id_produit)}>
          {t?.deconseille ? 'Rétablir' : 'Déconseiller'}
        </NdoeActionButton>
      ),
      user?.role === 'admin' && (
        <Popconfirm key="del" title="Supprimer ce produit ?" onConfirm={() => handleDelete(record.id_produit)} okText="Oui" cancelText="Non">
          <NdoeActionButton size="sm" variant="danger" icon={<DeleteOutlined />}>Suppr.</NdoeActionButton>
        </Popconfirm>
      ),
    ].filter(Boolean);

    return (
      <NdoeDataCard
        media={<NdoeImage src={record.img} alt={record.nom_produit || 'Produit'} size="lg" />}
        title={record.nom_produit}
        subtitle={[record.nom_categorie, record.nom_marque].filter(Boolean).join(' · ')}
        badge={<NdoeStatusBadge kind="custom" tone={tone} label={label} />}
        metrics={t ? [
          { value: t.physique, label: 'phys' },
          { value: t.reservee, label: 'rés' },
          { value: t.en_circulation, label: 'circ' },
          { value: t.avariees, label: 'avar' },
        ] : []}
        onClick={() => showModal(record.id_produit)}
        actions={actions}
      >
        {(t?.deconseille || t?.avariees > 0) && (
          <div style={{ marginTop: 8, display: 'flex', gap: 6, flexWrap: 'wrap' }}>
            {t?.deconseille && <span className="ndoe-badge ndoe-badge--warn">Déconseillé</span>}
            {t?.avariees > 0 && <span className="ndoe-badge ndoe-badge--danger">{t.avariees} mauvais état</span>}
          </div>
        )}
      </NdoeDataCard>
    );
  };

  return (
    <NdoePage>
      <NdoePageHeader
        eyebrow="Catalogue"
        title="Liste des produits"
        subtitle="Gérer vos produits et leur disponibilité"
        actions={
          // LA SECONDE PORTE (10/08/2026). Ce bouton ouvrait l'ANCIEN formulaire
          // dans une fenêtre : retirer l'entrée de menu sans le corriger n'aurait
          // rien fermé. Il mène maintenant à l'assistant, comme le menu.
          <NdoeActionButton variant="primary" icon={<PlusCircleOutlined />} onClick={() => navigate('/catalogue/nouveau')}>
            Nouveau modèle
          </NdoeActionButton>
        }
      />

      {/* L'ancien « Filtres avancés » (ProductSelects) est absorbé ici : marque
          et catégorie deviennent des facettes construites depuis les produits
          déjà chargés — pas d'appel serveur, et jamais un choix qui ne ramène rien. */}
      <NdoeRecherche
        q={searchValue}
        onQ={setSearchValue}
        placeholder="Produit, code, référence, marque, catégorie, matière, cible, état…"
        facettes={[
          { cle: 'marque', placeholder: 'Marque', options: optionsDe(getProduit, 'nom_marque'), valeur: marque, onChange: setMarque, largeur: 160 },
          { cle: 'categorie', placeholder: 'Catégorie', options: optionsDe(getProduit, 'nom_categorie'), valeur: categorie, onChange: setCategorie, largeur: 160 },
        ]}
        actifs={compterActifs(searchValue, marque, categorie)}
        onEffacer={() => { setSearchValue(''); setMarque(undefined); setCategorie(undefined); }}
        resume={`${filteredData.length} sur ${getProduit?.length || 0} produit${(getProduit?.length || 0) > 1 ? 's' : ''}`}
      />

      {/* Filtres stock (puces cliquables) — visibles desktop ET mobile */}
      <div className="ndoe-stats">
        {indicateurs.map((ind) => (
          <button
            type="button"
            key={ind.key}
            className={`ndoe-stat ${stockFilter === ind.key ? 'is-active' : ''}`}
            onClick={() => setStockFilter(ind.key)}
          >
            <span className="ndoe-stat__label">{ind.label}</span>
            <span className="ndoe-stat__value num">{ind.value}</span>
          </button>
        ))}
        {/* LES BROUILLONS SE COMPTENT SUR TOUT LE CATALOGUE, pas sur la page.
            Séparé visuellement pour cette raison : les puces voisines disent
            « sur cette page », celle-ci dit « en tout ». Les confondre ferait
            lire un chiffre pour un autre. */}
        {indicateurBrouillons && (
          <button
            type="button"
            key={indicateurBrouillons.key}
            className={`ndoe-stat ndoe-stat--brouillons ${voirBrouillons ? 'is-active' : ''}`}
            onClick={() => { setVoirBrouillons((v) => !v); setCurrentPage(1); }}
            title={voirBrouillons
              ? 'Revenir à tout le catalogue'
              : 'N’afficher que les fiches sans aucune pointure'}
          >
            <span className="ndoe-stat__label">{indicateurBrouillons.label} (tout le catalogue)</span>
            <span className="ndoe-stat__value num">{indicateurBrouillons.value}</span>
          </button>
        )}
      </div>

      {voirBrouillons && (
        <p className="np-raison np-raison--info" style={{ margin: '0 0 12px' }}>
          Vous ne voyez que les <b>fiches sans aucune pointure</b>. Elles
          n’apparaissent ni au catalogue, ni dans les ventes : complétez-les avec
          le bouton <b>+</b> de leur ligne, ou revenez à tout le catalogue.
        </p>
      )}

      <NdoeResponsiveTable
        data={filteredData}
        columns={columns}
        rowKey="id_produit"
        loading={loading}
        renderCard={renderProductCard}
        scroll={{ x: 'max-content' }}
        pagination={{
          current: currentPage,
          pageSize: pageSize,
          total: totalItems,
          pageSizeOptions: ['10', '20', '50', '100', '200', '300', '400', '500', '600', '800'],
          showSizeChanger: true,
        }}
        onChange={handleTableChange}
        empty={{ icon: '👟', title: 'Aucun produit', text: 'Ajustez la recherche ou les filtres.' }}
        mobilePager={
          <div style={{ marginTop: 16, display: 'flex', justifyContent: 'center' }}>
            <Pagination
              current={currentPage}
              pageSize={pageSize}
              total={Number(totalItems) || 0}
              showSizeChanger={false}
              onChange={(p, s) => handleTableChange({ current: p, pageSize: s })}
            />
          </div>
        }
      />

      {/* Drawer détail produit */}
      <Drawer
        title="Information du produit"
        placement="right"
        width={620}
        open={open}
        onClose={() => setOpen(false)}
        destroyOnClose
      >
        <Button
          type="link"
          style={{ paddingLeft: 0, marginBottom: 8 }}
          onClick={() => {
            const nom = getProduit?.find((p) => p.id_produit === idProduit)?.nom_produit;
            navigate(`/varianteProduit${nom ? `?q=${encodeURIComponent(nom)}` : ''}`);
          }}
        >
          Ouvrir dans le Catalogue visuel →
        </Button>
        <ProductDetail idProduit={idProduit} />
      </Drawer>

      {/* Modal changement d'état */}
      <Modal
        title="Etat produit"
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        onOk={async () => {
          try {
            await axios.put(`${DOMAIN}/api/produit/${selectedProductId}`);
            setModalVisible(false);
            Swal.fire({
              title: 'Success',
              text: "L'état des produits a été modifié avec succès.",
              icon: 'success',
              confirmButtonText: 'OK',
            });
            fetchData(currentPage, pageSize);   // refetch au lieu de recharger toute la page
          } catch (err) {
            Swal.fire({
              title: 'Error',
              text: err.message,
              icon: 'error',
              confirmButtonText: 'OK',
            });
          }
        }}
        centered
        cancelText={<span style={{ color: '#fff' }}>Annuler</span>}
        okText={<span style={{ color: '#fff' }}>Oui</span>}
        cancelButtonProps={{ style: { background: 'red' } }}
        okButtonProps={{ style: { background: 'blue' } }}
      >
        <p>Souhaitez-vous réellement désactiver ou réactiver ?</p>
      </Modal>

      {/* La fenêtre de création a été retirée avec l'ancien formulaire : la
          création passe par l'assistant « Nouveau modèle », qui crée le produit
          ET son premier arrivage en une transaction. */}
    </NdoePage>
  )
}

export default Products
